module.exports = __webpack_public_path__ + "static/tlo_palenie@2x-e14188d976e735dc110098560bab46a2.png";